import { BankrateOffer } from '@bankrate/mortgage-types'

export const eventTypes = {
  FormStarted: 'redventures.usertracking.v3.FormStarted',
  ProductViewed: 'redventures.ecommerce.v1.ProductViewed',
  ProductClicked: 'redventures.ecommerce.v1.ProductClicked',
  FormSubmitted: 'redventures.usertracking.v3.FormSubmitted',
  FieldInputted: 'redventures.usertracking.v3.FieldInputted',
  ElementViewed: 'redventures.usertracking.v3.ElementViewed',
  ElementClicked: 'redventures.usertracking.v3.ElementClicked',
  ProductListViewed: 'redventures.ecommerce.v1.ProductListViewed',
  ProductListFiltered: 'redventures.ecommerce.v1.ProductListFiltered',
  FormOutcomeReceived: 'redventures.authenticated.v1alpha1.FormOutcomeReceived',
  ProductAttributesCaptured: 'redventures.bankrate.v1.ProductAttributesCaptured',
}

export interface TrackingFieldModel {
  name: string
  type?: string
  label?: string
  value: string | number | boolean
}

export interface ViewTrackingModel {
  element: {
    type: string
    location: string
    position: string
    htmlId?: string
    text: string
    name: string
  }
}

export interface TrackingClickModel {
  element: {
    type: string
    location: string
    position: string
    htmlId?: string
    text: string
    name: string
  }
  outcome: string
  additionalSkipLowerCase?: string[]
}

// https://app.make.rvapps.io/schemas/sch_1KdMznrCEKg6eUKeA0LZnU2EOUe field
export interface EventField {
  fieldName: string
  fieldType: string
  fieldLabel: string
  fieldValue: string
}

export interface ProductTrackingParams {
  eventName: keyof typeof eventTypes
  position?: number
  offer?: BankrateOffer
  id?: string
  text?: string
}

export interface TrackingEmailFormModel {
  eventName: keyof typeof eventTypes
  stepName?: string
  authenticatedContext?: {
    userId: string
    appTenantId: string
  }
  element?: {
    type: string
    location: string
    position: string
    htmlId?: string
    text: string
    name: string
  }
}

export interface EventBeamModel {
  eventName: keyof typeof eventTypes
  skipLowerCase?: string[]
  eventPayload: object
}

/**
 * TypeScript (And mortgage specific) interfaces of the Make Schemas
 * URL: https://app.make.rvapps.io/schemas
 */

// while javascript only has the number type
// which is a float value, we can create an alias for integer
// so we can represent whether the make schema expects a float or an int
type integer = number

// https://app.make.rvapps.io/schemas/sch_1KdMzjSmvkUNkkjGM5VDHhjWIzQ
export interface MortgageTrackingProduct {
  brand: string
  category: string
  location: 'rate-table' | 'additional offers' | 'featured tab' | 'rate-table-stacked' | 'rate-table-all'
  price: number
  productId: string
  position: integer
  variant: string
  text: string
}

// shared between ProductListViewed/ProductListFiltered
export interface ProductList {
  listId: string
  field: EventField[]
  product: MortgageTrackingProduct[]
}

//https://app.make.rvapps.io/schemas/sch_1KdMznrCEKg6eUKeA0LZnU2EOUe
export interface ProductListViewed extends ProductList {
  category: string
  listName: string
  featuredListings: integer
  standardListings: integer
  sponsoredListings: integer
  editorialListings: integer
  reasonNoCoverage: string
}

// https://app.make.rvapps.io/schemas/sch_1KdN03T5dwth1kTtQrPbclkPUrc
export interface ProductListFiltered extends ProductList {
  sorts: Array<{ type: 'sort'; value: string }>
}

export type ListingType = 'featured' | 'sponsored' | 'editorial' | 'standard' | 'additional'

// https://app.make.rvapps.io/schemas/sch_1PSktDsPXlgvvDKnsk49vcpDmVQ
export interface ProductAttributes {
  productId: string
  productVertical: 'MORTGAGES'
  termUnit: 'years' | ''
  listingType: ListingType
  rating: string
  bankrateScore: '0'
  matchType: '0%'
  rate: number
  apr: number
  sectionalPosition: integer
  termLength?: integer
  points: number
  fees: integer
  loanAmount: number
}
